import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { MatDialogRef } from '@angular/material/dialog';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { FilterFloorsComponent } from 'src/app/floor-management/filter-floors/filter-floors.component';
import { IFloor } from 'src/app/floor-management/floor-management-interface';
import { IFilterFloor } from 'src/app/shared/state-management/state-interfaces';
import { FilterUsersComponent } from '../../filter-users/filter-users.component';
import { UserTypeRequest } from 'src/app/shared/constants/request-mapping';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-multi-user-selection-list',
  templateUrl: './multi-user-selection-list.component.html',
  styleUrls: ['./multi-user-selection-list.component.scss'],
})
export class MultiUserSelectionListComponent implements OnInit {
  /**
   * all necessary input get values from parent
   */

  formGroup!: FormGroup;
  submited = false;
  public toggleSubHeading = false;
  validateUser = false;
  selectedSiteId?: String | null;
  usersCopy: any | undefined;
  searchKeyPress: boolean = false;
  markAll: any;
  profileImageLoader: string = CONSTANTS.PROFILE_IMAGE_LOADER;
  profileImageSrc: string = 'assets/svg/ico-user-with-gray-circle.svg';
  commonAccessControl!: boolean;
  @Input() selectedUsers: any[] = [];
  @Input() singleUsersSelected: string[] = [];
  @Input() users: any[] = [];
  @Input() isDashboard!: boolean;
  @Input() stepper!: number;
  @Input() flowType!: string;
  @Output() stepperChange = new EventEmitter<number>();
  @Input() userType!: any;
  @Output() userTypeChange = new EventEmitter<any>();
  @Output() submitSelectedUsers = new EventEmitter<any>();
  @Output() submitToParent = new EventEmitter<any>();
  
  readonly LANG_CONST = LANG_CONST;
  CONSTANTS = CONSTANTS;
  currentAlphabet!: string;
  filterCount: number = 0;
  filter!: IFilterFloor;
  rolesSelected: string[] | undefined = [];
  constructor(
    private dialogRef: MatDialogRef<MultiUserSelectionListComponent>,
    private sharedDataService: SharedDataService,
    private helperService: HelperService,
    public stateManagementService: StateManagementService,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.localizationService.setupLocalization();
    if (this.flowType === CONSTANTS.USER_GROUP) {
      this.users = this.users?.map((user: any) => {
        if (this.singleUsersSelected?.includes(user?.userId)) {
          return { ...user, alreadySelected: true, status: true };
        } else return user;
      });
    }
    this.commonAccessControl = this.stateManagementService.getSharedData()?.selectedSite?.commonAccessControl;
    this.usersCopy = Object.assign([], this.users);
    this.validateUserSubmit();
    this.markAll = this.sharedDataService.markAll;
  }

  /**
   * @description validate form if form valid redirect to other stepper
   * @returns void
   */
  submit(): void {
    const selectedUsers = this.users?.filter(
      (user: any) => user?.status && !user.alreadySelected
    );
    this.selectedUsers = selectedUsers;
    this.submitSelectedUsers?.emit(selectedUsers);
    if(!this.commonAccessControl){
      let userDetail: any = {};
      userDetail.startTime = CONSTANTS.NOW;
      this.submitToParent?.emit(userDetail);
    }
    this.userTypeChange?.emit(this.userType);
  }
  /**
   * @param unit current unit id
   * @description update unit status
   * returns void
   */
  updateUserStatus(user: any): void {
    if (user.alreadySelected === true) {
      return;
    }
    user.status = !user.status;
    this.checkAllMarkUnits();
    this.validateUserSubmit();
  }

  /**
   * @description toggle check if all selected set value true else false
   * @returns void
   */
  checkAllMarkUnits(): void {
    if (this.users?.length == this.usersCopy?.flat()?.length) {
      this.markAll = this.users
        ?.filter((user: any) => user?.name)
        ?.every((user: any) => user.status === true);
    } else {
      this.markAll = this.usersCopy
        ?.filter((user: any) => user?.userId)
        ?.every((user: any) => user.status === true);
    }

    this.sharedDataService.markAll = this.markAll;
  }

  /**
   * @description any of unit or even access point select submit button unable
   * @returns void
   */
  validateUserSubmit(): void {
    this.validateUser = this.users?.some(
      (user: any) => user.status === true && !user.alreadySelected
    );
  }

  /**
   * @param flatFloorUnit floors of units with flat array
   * @description check value exists on control
   * if exists call removeRecordBuildingId function
   * else set new value
   * @returns void
   */
  setEntitiesControlVal(flatFloorUnit: any): void {}

  /**
   * @param buildingId current building id
   * @description remove all record from selected building id
   * @returns void
   */
  removeRecordBuildingId(buildingId: string | undefined): void {}

  /**
   * @description hold old and append with new value if find similar changes
   * @returns void
   */
  addNewEntityByBuildingId(): void {}

  /**
   * @param param {buildingId} selected building
   * @description get the count of selected units add back to building object
   * @returns void
   */
  getCount({ buildingId }: { buildingId: string }): number {
    return this.users?.filter(
      (accesspoint: any) =>
        accesspoint.status && accesspoint.building == buildingId
    )?.length;
  }

  /**
   * @description select unselect all list item
   * @returns void
   */
  markList() {
    this.users?.filter((user: any) => {
      if (!user.alreadySelected) user.status = this.markAll;
    });
    this.usersCopy?.filter((user: any) => {
      if (!user.alreadySelected) user.status = this.markAll;
    });
    this.sharedDataService.markAll = this.markAll;
    this.validateUserSubmit();
  }

  /**
   * @param event selected value
   * @description search any keyword
   * this method will be implemented when search unit funcition
   * will be added to this.
   * @returns void
   */
  searchUsers(data: string): void {
    if (data && data !== '') {
      this.users = this.usersCopy.filter((user: any) =>
        user?.name?.toLowerCase()?.includes(data.toLowerCase())
      );
    } else {
      this.users = Object.assign([], this.usersCopy);
      this.checkAllMarkUnits();
    }
  }

  /**
   * @description filter units
   * @returns void
   * @note this function will be use in future right now we don't have any filter functionality
   */
  onFilterUser(): void {}

  /**
   * @description: #checkIfNew function will check for new alphabet
   * @inut {none}
   * @output {void}
   */
  checkIfNew(name: string) {
    if (this.currentAlphabet === name?.charAt(0).toLowerCase()) return false;
    this.currentAlphabet = name?.charAt(0).toLowerCase();
    return true;
  }

  updateUserCopy(updatedUsers: any): void {
    this.users = updatedUsers;
    this.usersCopy = Object.assign([], this.users);
   this.markAll= this.users.every(user => user.alreadySelected);
    this.validateUserSubmit();
  }

  /**
   * @description close modal popup
   * @returns void
   */
  closeDialog() {
    this.sharedDataService.markAll = false;
    this.dialogRef?.close();
  }

  /**
   * @description: onFilterUnit function function opens the modal poup for Edit unit.
   * @input none
   * @output { void }
   */

  selectFilter() {
    const dialogRef = this.helperService.openModalDialog(
      FilterUsersComponent,
      this.rolesSelected,
      [CONSTANTS.FIXED_SCREEN_MODAL]
    );

    dialogRef?.afterClosed().subscribe((filterUsers: string[]) => {
      if (filterUsers) {
        this.rolesSelected = filterUsers;
        const mappingTypes = filterUsers?.map((userRole: any) => {
          return userRole === 5 || userRole === 6 ? 7 : userRole;
        });
        if (this.rolesSelected.length > 0) {
          this.users = this.usersCopy.filter((user: any) =>
            mappingTypes.includes(UserTypeRequest[this.translate.instant(user.userType)])
          );
        } else {
          this.users = [...this.usersCopy];
        }
      } else return;
      this.filterCount = this.rolesSelected?.length;
    });
  }
}
